import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Button,
  message,
  Spin,
  Input,
  Select,
  Tag,
} from "antd";
import { useState, useCallback, useMemo, useEffect } from "react";
import {
  ReloadOutlined,
  InboxOutlined,
  FileSearchOutlined,
  TruckOutlined,
  FileProtectOutlined,
} from "@ant-design/icons";
import {
  HEADERS_EXPORT_BEN,
  POST_ACCEPT_ACC_RECHECK_JUDGE_DOC,
  POST_MAIN_RECHECK_JUDGE_DOC,
} from "../../API/apiUrls";
import axios from "axios";
import MotionHoc from "../../../utils/MotionHoc";
import AccApproval from "./modal/AccApproval";
import dayjs from "dayjs";

const { Option } = Select;

const STATUS_GROUP = {
  16: "A",
  19: "B",
  99: "C",
  22: "C",
  1: "C",
  2: "C",
  3: "C",
  4: "C",
  5: "C",
  6: "C",
  13: "C",
  21: "D",
};

const STATUS_RULES = [
  {
    match: (r) => r.currentStatus === 21 && r.closeContno,
    label: "ตีกลับ",
    color: "red",
  },
  {
    match: (r) => r.currentStatus === 13 && r.closeContno,
    label: "ส่งอุธรณ์",
    color: "red",
  },
  {
    match: (r) =>
      r.currentStatus === 16 &&
      // !r.checkJudge &&
      // !r.checkJudgeAcc &&
      // !r.checkJudgeCeo &&
      // !r.checkJudgeFn &&
      r.rejudgeFromIdJudge,
    label: "รอรับงานรีไฟแนนซ์",
    color: "red",
  },
  {
    match: (r) =>
      r.currentStatus === 16 &&
      // !r.checkJudge &&
      // !r.checkJudgeAcc &&
      // !r.checkJudgeCeo &&
      // !r.checkJudgeFn &&
      r.closeContno,
    label: "รอรับงาน",
    color: "red",
  },
  {
    match: (r) =>
      r.currentStatus === 19 && r.checkJudge && r.rejudgeFromIdJudge,
    label: "รอบัญชีตรวจรีไฟแนนซ์",
    color: "blue",
  },

  {
    match: (r) =>
      r.currentStatus === 19 &&
      r.checkJudge &&
      !r.checkJudgeAcc &&
      !r.checkJudgeCeo &&
      !r.checkJudgeFn &&
      r.closeContno,
    label: "รอบัญชีตรวจ",
    color: "blue",
  },

  {
    match: (r) =>
      (r.currentStatus === 20 || r.currentStatus === 17) &&
      r.checkJudge &&
      r.checkJudgeAcc &&
      !r.checkJudgeCeo &&
      !r.checkJudgeFn &&
      r.closeContno,
    label: "รอ CEO อนุมัติ",
    color: "warning",
  },
  {
    match: (r) => r.currentStatus === 22 && r.checkJudge && r.checkJudgeAcc,
    label: "ยึดรอไถ่ถอน",
    color: "warning",
  },
  {
    match: (r) =>
      (r.SCHEMA === "vsfhp" || r.SCHEMA === "rpsl") &&
      (r.LAW_TYPE_ID !== 6 || r.flagArlost !== 1) &&
      !r.flagArlost &&
      r.checkJudge &&
      r.checkJudgeAcc &&
      r.checkJudgeCeo &&
      !r.checkJudgeFn &&
      r.closeContno &&
      r.currentStatus !== 13,
    label: "รอยึด",
    color: "orange",
  },
  {
    match: (r) =>
      (r.SCHEMA === "vsfhp" || r.SCHEMA === "rpsl") &&
      r.LAW_TYPE_ID !== 6 &&
      r.flagArlost === 0 &&
      r.checkJudge &&
      r.checkJudgeAcc &&
      r.checkJudgeCeo &&
      !r.checkJudgeFn &&
      !r.closeContno,
    label: "ยึดแล้ว",
    color: "purple",
  },
  {
    match: (r) =>
      (r.SCHEMA === "vsfhp" || r.SCHEMA === "rpsl") &&
      (r.LAW_TYPE_ID === 6 || r.flagArlost === 1) &&
      r.checkJudge &&
      r.checkJudgeAcc &&
      r.checkJudgeCeo &&
      !r.checkJudgeFn &&
      r.closeContno,
    label: "รอตัดจ่าย",
    color: "pink",
  },
  {
    match: (r) =>
      (r.SCHEMA === "sfhp" || r.SCHEMA === "lsfhp") &&
      r.checkJudge &&
      r.checkJudgeAcc &&
      r.checkJudgeCeo &&
      !r.checkJudgeFn &&
      r.closeContno,
    label: "รอตัดจ่าย",
    color: "pink",
  },
  {
    match: (r) =>
      (r.SCHEMA === "sfhp" || r.SCHEMA === "lsfhp") &&
      r.checkJudge &&
      r.checkJudgeAcc &&
      r.checkJudgeCeo &&
      r.checkJudgeFn &&
      r.closeContno,
    label: "ตัดจ่ายแล้ว (ยังไม่ปิดบัญชี)",
    color: "geekblue",
  },
  {
    match: (r) =>
      (r.SCHEMA === "vsfhp" || r.SCHEMA === "rpsl") &&
      (r.LAW_TYPE_ID === 6 || r.flagArlost === 1) &&
      r.checkJudge &&
      r.checkJudgeAcc &&
      r.checkJudgeCeo &&
      r.checkJudgeFn &&
      r.closeContno,
    label: "ตัดจ่ายแล้ว (ยังไม่ปิดบัญชี)",
    color: "geekblue",
  },
  {
    match: (r) =>
      (r.SCHEMA === "sfhp" || r.SCHEMA === "lsfhp") &&
      r.checkJudge &&
      r.checkJudgeAcc &&
      r.checkJudgeCeo &&
      r.checkJudgeFn &&
      !r.closeContno,
    label: "ตัดจ่ายแล้ว (ปิดบัญชีแล้ว)",
    color: "green",
  },
  {
    match: (r) =>
      (r.SCHEMA === "vsfhp" || r.SCHEMA === "rpsl") &&
      (r.LAW_TYPE_ID === 6 || r.flagArlost === 1) &&
      r.checkJudge &&
      r.checkJudgeAcc &&
      r.checkJudgeCeo &&
      r.checkJudgeFn &&
      !r.closeContno,
    label: "ตัดจ่ายแล้ว (ปิดบัญชีแล้ว)",
    color: "green",
  },
  {
    match: (r) =>
      (r.SCHEMA === "sfhp" || r.SCHEMA === "lsfhp") &&
      r.checkJudge &&
      r.checkJudgeAcc &&
      r.checkJudgeCeo &&
      !r.checkJudgeFn &&
      !r.closeContno,
    label: "ปิดบัญชีแล้ว (ยังไม่ตัดจ่าย)",
    color: "gray",
  },
  {
    match: (r) =>
      (r.SCHEMA === "vsfhp" || r.SCHEMA === "rpsl") &&
      (r.LAW_TYPE_ID === 6 || r.flagArlost === 1) &&
      r.checkJudge &&
      r.checkJudgeAcc &&
      r.checkJudgeCeo &&
      !r.checkJudgeFn &&
      !r.closeContno,
    label: "ปิดบัญชีแล้ว (ยังไม่ตัดจ่าย)",
    color: "gray",
  },
];

// ✅ FILTER_RULES แยกตาม statusOptions value
const FILTER_RULES = {
  16: (r) => r.currentStatus === 16,
  19: (r) => r.currentStatus === 19,
  21: (r) => r.currentStatus === 21,
  13: (r) => r.currentStatus === 13,
  99: (r) => STATUS_RULES.find((s) => s.label === "รอ CEO อนุมัติ")?.match(r),
  22: (r) => STATUS_RULES.find((s) => s.label === "ยึดรอไถ่ถอน")?.match(r),
  1: (r) => STATUS_RULES.find((s) => s.label === "รอยึด")?.match(r),
  2: (r) => STATUS_RULES.find((s) => s.label === "ยึดแล้ว")?.match(r),
  3: (r) =>
    STATUS_RULES.filter((s) => s.label === "รอตัดจ่าย").some((s) => s.match(r)),
  4: (r) =>
    STATUS_RULES.filter((s) => s.label === "ตัดจ่ายแล้ว (ปิดบัญชีแล้ว)").some(
      (s) => s.match(r),
    ),
  5: (r) =>
    STATUS_RULES.filter((s) => s.label === "ตัดจ่ายแล้ว (ยังไม่ปิดบัญชี)").some(
      (s) => s.match(r),
    ),
  6: (r) =>
    STATUS_RULES.filter((s) => s.label === "ปิดบัญชีแล้ว (ยังไม่ตัดจ่าย)").some(
      (s) => s.match(r),
    ),
};

// const STATUS_DATE = [
//   {
//     match: (r) => r.currentStatus === 13 && r.closeContno,
//     label: "ส่งอุธรณ์",
//     color: "red",
//     dateField: "dtAppeal",
//   },
//   {
//     match: (r) => !r.checkJudge && !r.checkJudgeAcc && !r.checkJudgeCeo && !r.checkJudgeFn && r.closeContno,
//     label: "รอเบลตรวจ",
//     color: "default",
//     dateField: "dtCompleteCheckJudge",
//   },
//   {
//     match: (r) => r.checkJudge && !r.checkJudgeAcc && !r.checkJudgeCeo && !r.checkJudgeFn && r.closeContno,
//     label: "รอบัญชีตรวจ",
//     color: "blue",
//     dateField: "dtCompleteCheckJudge", // เบลตรวจเสร็จเมื่อ
//   },
//   {
//     match: (r) => r.checkJudge && r.checkJudgeAcc && !r.checkJudgeCeo && !r.checkJudgeFn && r.closeContno,
//     label: "รอ CEO อนุมัติ",
//     color: "warning",
//     dateField: "dtCompleteAcc", // บัญชีตรวจเสร็จเมื่อ
//   },
//   {
//     match: (r) => (r.SCHEMA === "vsfhp" || r.SCHEMA === "rpsl") && r.checkJudge && r.checkJudgeAcc && r.checkJudgeCeo && r.closeContno && r.currentStatus !== 13,
//     label: "รอยึด",
//     color: "orange",
//     dateField: "dtApproveCeo",
//   },
//   {
//     match: (r) => (r.SCHEMA === "vsfhp" || r.SCHEMA === "rpsl") && r.checkJudge && r.checkJudgeAcc && r.checkJudgeCeo && !r.closeContno,
//     label: "ยึดแล้ว",
//     color: "purple",
//     dateField: "dtSeize",
//   },
//   {
//     match: (r) => (r.SCHEMA === "sfhp" || r.SCHEMA === "lsfhp") && r.checkJudge && r.checkJudgeAcc && r.checkJudgeCeo && !r.checkJudgeFn && r.closeContno,
//     label: "รอตัดจ่าย",
//     color: "pink",
//     dateField: "dtApproveCeo",
//   },
//   {
//     match: (r) => (r.SCHEMA === "sfhp" || r.SCHEMA === "lsfhp") && r.checkJudge && r.checkJudgeAcc && r.checkJudgeCeo && r.checkJudgeFn && r.closeContno,
//     label: "ตัดจ่ายแล้ว (ยังไม่ปิดบัญชี)",
//     color: "geekblue",
//     dateField: "dtPayOff",
//   },
//   {
//     match: (r) => (r.SCHEMA === "sfhp" || r.SCHEMA === "lsfhp") && r.checkJudge && r.checkJudgeAcc && r.checkJudgeCeo && r.checkJudgeFn && !r.closeContno,
//     label: "ตัดจ่ายแล้ว (ปิดบัญชีแล้ว)",
//     color: "green",
//     dateField: "dtPayOff",
//   },
// ];

const statusOptions = [
  { value: 16, icon: "📤 ", label: "รอรับงาน" },
  { value: 19, icon: "🕒 ", label: "รอตรวจสอบ" },
  { value: 99, icon: "✅ ", label: "ตรวจสอบแล้ว" },
  { value: 22, icon: "⏳ ", label: "ยึดรอไถ่ถอน" },
  { value: 1, icon: "🟠 ", label: "รอยึด" },
  { value: 2, icon: "🟣 ", label: "ยึดแล้ว" },
  { value: 3, icon: "🟡 ", label: "รอตัดจ่าย" },
  { value: 4, icon: "🟢 ", label: "ตัดจ่ายแล้ว (ปิดบัญชีแล้ว)" },
  { value: 5, icon: "🔵 ", label: "ตัดจ่ายแล้ว (ยังไม่ปิดบัญชี)" },
  { value: 6, icon: "⚪ ", label: "ปิดบัญชี (ยังไม่ตัดจ่าย)" },
  { value: 13, icon: "🛑 ", label: "ส่งอุธรณ์" },
  { value: 21, icon: "↩️ ", label: "ตีกลับหาเบล" },
];

const Main = () => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  // States
  const [dataArr, setDataArr] = useState([]);
  const [rawArr, setRawArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInputTable, setSearchInputTable] = useState("");
  const [processStatus, setProcessStatus] = useState(16);
  const [dataRecord, setDataRecord] = useState(null);
  const [isModal, setIsModal] = useState(false);
  // Selection states
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const filterData = useCallback(
    (rawData, status) => {
      const rule = FILTER_RULES[status];
      if (!rule) return;

      const filtered = rawData?.filter(rule) || [];

      const getLatestTimestamp = (item) => {
        const dates = [
          item.dateCloseContno,
          item.dateCheckJudgeFn,
          item.dateCheckJudgeCeo,
          item.dateCheckJudgeAcc,
        ];

        const timestamps = dates
          .filter((date) => date)
          .map((date) => new Date(date).getTime());

        return timestamps.length > 0 ? Math.max(...timestamps) : 0;
      };
      const sorted = [...filtered].sort((a, b) => {
        return getLatestTimestamp(b) - getLatestTimestamp(a);
      });
      if (sorted.length === 0) {
        message.info("ไม่พบข้อมูล");
      }
      console.log("sorted", sorted);

      setDataArr(sorted);
    },
    [setDataArr],
  );

  const loadMain = useCallback(
    async (status, filterStatus = status) => {
      setLoading(true);
      setDataArr([]);
      setRawArr([]);

      console.log("status", status, filterStatus);

      try {
        const res = await axios.post(
          POST_MAIN_RECHECK_JUDGE_DOC,
          { userId, currentStatus: status },
          { headers: HEADERS_EXPORT_BEN },
        );

        if (res.data?.length > 0) {
          filterData(res.data, filterStatus);
          setRawArr(res.data);
        } else {
          setDataArr([]);
        }
      } catch (error) {
        if (error.name !== "CanceledError") {
          message.error(
            error.response?.data?.message ||
              error.message ||
              "ไม่สามารถโหลดข้อมูลได้",
          );
          setDataArr([]);
        }
      } finally {
        setLoading(false);
      }
    },
    [userId, filterData],
  );

  const handleChangeStatus = useCallback(
    (value) => {
      setProcessStatus(value);
      setDataArr([]);

      const isSameGroup = STATUS_GROUP[value] === STATUS_GROUP[processStatus];
      console.log("isSameGroup", isSameGroup);

      if (isSameGroup) {
        filterData(rawArr, value);
      } else {
        const loadStatus =
          value !== 16 && value !== 19 && value !== 21 ? 99 : value;
        loadMain(loadStatus, value);
      }
    },
    [processStatus, rawArr, filterData, loadMain],
  );

  useEffect(() => {
    if ((ROLE_ID === "12" || ROLE_ID === "1") && processStatus === 16) {
      loadMain(processStatus);
    }
  }, []);

  // ✅ กรองข้อมูลอัตโนมัติด้วย useMemo
  const arrayTable = useMemo(() => {
    if (!dataArr || dataArr.length === 0) return [];

    const normalize = (value) =>
      String(value ?? "")
        .trim()
        .toLowerCase();

    const searchQuery = normalize(searchInputTable);

    return dataArr.filter((item) => {
      const passQuery =
        !searchQuery ||
        [
          item.newContno,
          item.CUSCOD,
          item.CONTNO,
          item.NAME1,
          item.NAME2,
          `${item.SNAM || ""}${item.NAME1 || ""} ${item.NAME2 || ""}`,
        ]
          .map(normalize)
          .some((val) => val.includes(searchQuery));

      return passQuery;
    });
  }, [dataArr, searchInputTable]);

  // ✅ ฟังก์ชันล้างฟิลเตอร์
  const handleResetFilter = useCallback(() => {
    setSearchInputTable("");
    message.info("ล้างตัวกรองสำเร็จ");
  }, []);

  const handleReloadJudgment = useCallback(
    (payload) => {
      if (payload?.action !== "refresh") return;

      clearSelectedRows();
      setDataRecord(null);
      console.log("payload", payload);

      const value = payload?.status;
      const loadStatus = value !== 16 && value !== 19 ? 99 : value;

      console.log("loadStatus", loadStatus, value);
      loadMain(loadStatus, value);
    },
    [loadMain, processStatus],
  );

  const postDocStatus = async (payload, apiUse) => {
    console.log("📤 POST_DOC_STATUS with data:", payload);

    try {
      const res = await axios.post(apiUse, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      const { status, data } = res;

      if (status === 200) {
        console.log("✅ API Response:", data);
        return data;
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else if (status === 400) {
        message.error(`ข้อมูลไม่ถูกต้อง: ${serverMsg}`);
      } else if (status === 500) {
        message.error("เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ (500)");
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
        );
      }

      console.error("❌ postDocStatus error:", error);
      throw error;
    }
  };

  const handleBulkSave = async () => {
    if (selectedRowKeys.length === 0) {
      message.warning("กรุณาเลือกรายการที่ต้องการดำเนินการ");
      return;
    }

    setLoading(true);
    let successCount = 0;
    let failCount = 0;

    try {
      const selectedRecords = arrayTable.filter((item) =>
        selectedRowKeys.includes(item.CONTNO),
      );
      console.log(`📤 กำลังส่งข้อมูล ${selectedRecords.length} รายการ...`);

      for (const record of selectedRecords) {
        try {
          const payload = {
            loanId: record.loanId,
            lawsuitId: record.lawsuitId,
            userId: userId,
          };

          const result = await postDocStatus(
            payload,
            POST_ACCEPT_ACC_RECHECK_JUDGE_DOC,
          );
          successCount++;
          console.log(`✅ สำเร็จ: ${record.CONTNO}`);
        } catch (err) {
          failCount++;
          console.error(`❌ ล้มเหลว: ${record.CONTNO}`, err);
        }
      }

      if (successCount > 0) {
        message.success(
          `รับงานสำเร็จ ${successCount} รายการ${
            failCount > 0 ? `, ล้มเหลว ${failCount} รายการ` : ""
          }`,
        );

        // ✅ ส่ง payload ให้ถูกต้อง
        handleReloadJudgment({
          action: "refresh",
          status: processStatus,
        });
      } else {
        message.error("ไม่สามารถดำเนินการได้");
      }
    } catch (err) {
      console.error("❌ Error in bulk save:", err);
      message.error("เกิดข้อผิดพลาดในการดำเนินการ");
    } finally {
      setLoading(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
      console.log("Selected Keys:", selectedKeys);
    },
    getCheckboxProps: (record) => ({}),
  };

  const clearSelectedRows = () => {
    setSelectedRowKeys([]);
  };

  const renderStatus = (record) => {
    const rule = STATUS_RULES.find((s) => s.match(record));
    // const dateValue = record[rule.dateField];
    if (!rule) return <Tag>ไม่มีสถานะ</Tag>;

    return (
      <>
        <Tag color={rule.color}>{rule.label}</Tag>

        {/* {dateValue && (
          <>
            <br />
            <Tag color="default" style={{ margin: 0, fontSize: 11 }}>
              {dayjs(dateValue).add(543, "year").format("D MMM YY")}
            </Tag>
          </>
        )} */}
      </>
    );
  };

  // ✅ Columns สำหรับตาราง
  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 80,
      render: (_, __, index) => index + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      width: 150,
    },
    {
      title: "เลขสัญญาใหม่",
      dataIndex: "newContno",
      key: "newContno",
      align: "center",
      width: 150,
    },
    {
      title: "ชื่อ-นามสกุล",
      key: "fullName",
      align: "center",
      render: (_, record) => (
        <span>
          {`${record.SNAM || ""}${record.NAME1 || ""} ${
            record.NAME2 || ""
          }`.trim()}
        </span>
      ),
    },
    {
      title: "ผลพิจารณา",
      dataIndex: "redCaseNumber",
      key: "redCaseNumber",
      align: "center",
      render: (text, record) => {
        return (
          <div>
            <Tag
              color={record.flagLoanNew === 1 ? "green" : "red"}
              style={{ textAlign: "center" }}
            >
              {record.flagLoanNew === 1
                ? record.LAW_TYPE_ID === 6
                  ? "ทำยอม(ฟ้องส่วนต่าง)"
                  : "ทำยอม"
                : record.LAW_TYPE_ID === 6
                  ? "พิพากษา(ฟ้องส่วนต่าง)"
                  : "พิพากษา"}
            </Tag>
          </div>
        );
      },
    },
    (processStatus === 22 || processStatus === 1) && {
      title: "วันที่เฮียอนุมัติ",
      align: "center",
      render: (text, record) => (
        <div>
          {record.dtCompleteCheckJudgeCeo &&
            dayjs(record.dtCompleteCheckJudgeCeo)
              .add(543, "year")
              .format("DD/MM/YY")}
        </div>
      ),
    },
    [2, 4, 5, 6].includes(processStatus) && {
      title: "วันที่ยึด/ตัดจ่าย",
      align: "center",
      render: (_, record) =>
        record.dtCompleteCheckJudgeCeo
          ? dayjs(record.dtCompleteCheckJudgeCeo)
              .add(543, "year")
              .format("DD/MM/YY")
          : null,
    },
    {
      title: "สถานะ",
      align: "center",
      render: (_, record) => renderStatus(record),
    },

    // {
    //   title: "วันที่ดำเนินการ",
    //   align: "center",
    //   render: (text, record) => {
    //     const statusConfig = {
    //       16: {
    //         field: record.dtCompleteCheckJudge,
    //         label: "เบลตรวจ",
    //         color: "red",
    //       },
    //       19: {
    //         field: record.dtAcceptAcc,
    //         label: "รับงานเมื่อ",
    //         color: "blue",
    //       },
    //       20: {
    //         field: record.dtCompleteAcc,
    //         label: "ตรวจสำเร็จเมื่อ",
    //         color: "green",
    //       },
    //     };

    //     const config = statusConfig[record.currentStatus];

    //     if (!config || !config.field) {
    //       return <Tag color="default">-</Tag>;
    //     }
    //     return (
    //       <div>
    //         <Tag color={config.color} style={{ textAlign: "center" }}>
    //           {config.label}
    //           <br />
    //           {dayjs(config.field).add(543, "year").format("D MMM YY")}
    //         </Tag>
    //       </div>
    //     );
    //   },
    // },
    processStatus !== 16 && {
      title: "การจัดการ",
      key: "actions",
      align: "center",
      width: 180,
      render: (_, record) => {
        const statusRule = STATUS_RULES.find((s) => s.match(record)); // ✅ หา rule ที่ match

        return (
          <>
            <Button
              color={statusRule?.color ?? "default"} // ✅ ใช้สีจาก STATUS_RULES
              variant="outlined"
              icon={
                processStatus === 19 ? (
                  <FileSearchOutlined />
                ) : processStatus === 1 ? (
                  <TruckOutlined />
                ) : (
                  <FileProtectOutlined />
                )
              }
              onClick={() => {
                console.log("record----->", record);

                setDataRecord(record);
                setIsModal(true);
              }}
            >
              {processStatus === 19
                ? "ตรวจข้อมูล"
                : processStatus === 1
                  ? "กดยึด"
                  : "ดูข้อมูล"}
            </Button>
          </>
        );
      },
    },
  ].filter(Boolean);

  return (
    <>
      <Card
        style={{
          marginBottom: 8,
          borderRadius: 12,
          border: "1px solid #ffcb05",
          background: "#fffdf0",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 12px",
              borderRadius: 8,
              background: "#fff3cc",
              border: "1px solid #ffcb05",
            }}
          >
            <span style={{ fontSize: 14, color: "#efa420" }}>🔍</span>
            <span
              style={{
                fontSize: 13,
                fontWeight: 500,
                color: "#efa420",
                whiteSpace: "nowrap",
              }}
            >
              เลือกสถานะ
            </span>
          </div>

          <Select
            size="large"
            style={{ minWidth: 240 }}
            placeholder="เลือกสถานะ"
            value={processStatus}
            onChange={(v) => {
              handleChangeStatus(v);
              setSearchInputTable("");
            }}
            optionLabelProp="label"
          >
            {statusOptions.map(({ value, icon, label }) => (
              <Option key={value} value={value} label={`${icon} ${label}`}>
                <Space>
                  <span style={{ fontSize: 14 }}>{icon}</span>
                  <span>{label}</span>
                </Space>
              </Option>
            ))}
          </Select>

          {/* ✅ Tag ชิดขวา */}
          {processStatus &&
            (() => {
              const found = statusOptions.find(
                (o) => o.value === processStatus,
              );
              return found ? (
                <Tag
                  style={{
                    marginLeft: "auto",
                    fontSize: 13,
                    borderRadius: 20,
                    padding: "3px 12px",
                    background: "#fff3cc",
                    border: "1px solid #ffcb05",
                    color: "#efa420",
                    fontWeight: 500,
                  }}
                >
                  {found.icon} {found.label}
                </Tag>
              ) : null;
            })()}
        </div>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
          <Row gutter={[0, 16]}>
            {/* Filters */}
            <Col span={12} style={{ textAlign: "start" }}>
              {processStatus === 16 && (
                <Button
                  type="primary"
                  ghost
                  danger
                  icon={<InboxOutlined />}
                  onClick={() => handleBulkSave()}
                  disabled={selectedRowKeys.length === 0}
                >
                  📥 รับงาน ({selectedRowKeys.length})
                </Button>
              )}
            </Col>
            <Col span={12} style={{ textAlign: "end" }}>
              <Space size={10} wrap>
                <Input
                  placeholder="ค้นหาเลขสัญญา, ชื่อ"
                  value={searchInputTable}
                  onChange={(e) => setSearchInputTable(e.target.value)}
                  style={{ width: 250, borderRadius: 8 }}
                  size="small"
                  allowClear
                  suffix={<span style={{ marginRight: 5 }}>🔍</span>}
                />

                <Button
                  icon={<ReloadOutlined />}
                  onClick={handleResetFilter}
                  size="large"
                  style={{
                    borderRadius: 8,
                    backgroundColor: "#fff1f0",
                    borderColor: "#ffa39e",
                    color: "#cf1322",
                  }}
                >
                  ล้างตัวกรอง
                </Button>
              </Space>
            </Col>

            {/* Table */}
            <Col span={24}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                rowKey={(record) => record.CONTNO || record.id}
                scroll={{ x: 1000 }}
                rowSelection={processStatus === 16 ? rowSelection : null}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  showTotal: (total) => `ทั้งหมด ${total} รายการ`,
                  pageSizeOptions: ["10", "20", "50", "100"],
                }}
                footer={() => (
                  <div style={{ alignItems: "center" }}>
                    <p style={{ margin: 0 }}>
                      จำนวนสัญญาทั้งหมด {arrayTable?.length}{" "}
                      {processStatus === 11 &&
                        ` | เลือก ${selectedRowKeys.length} รายการ`}
                    </p>
                  </div>
                )}
              />
            </Col>
          </Row>
        </Spin>
        {isModal && (
          <AccApproval
            open={isModal}
            close={() => setIsModal(false)}
            dataDefault={dataRecord}
            func={handleReloadJudgment}
            process={processStatus}
          />
        )}
      </Card>
    </>
  );
};

const MainReCheckJudgement = MotionHoc(Main);
export default MainReCheckJudgement;
